import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 16);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (!open) return undefined;
    const handleKey = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [open]);

  const closeMenu = () => setOpen(false);

  const scrollToSection = (event, sectionId) => {
    event.preventDefault();
    closeMenu();

    if (location.pathname !== '/') {
      navigate('/');
      window.setTimeout(() => {
        document.getElementById(sectionId)?.scrollIntoView({
          behavior: 'smooth'
        });
      }, 100);
      return;
    }

    document.getElementById(sectionId)?.scrollIntoView({
      behavior: 'smooth'
    });
  };

  return (
    <header className={`header ${scrolled ? 'header--scrolled' : ''}`}>
      <Link
        className="brand"
        to="/"
        aria-label="GEN IT SOLUTIONS INC home"
        onClick={(event) => {
          event.preventDefault();
          closeMenu();
          if (location.pathname !== '/') {
            navigate('/');
          }
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }}
      >
        <span className="brand-mark">G</span>
        <span>
          GEN IT <span className="brand-muted">SOLUTIONS INC</span>
        </span>
      </Link>

      <button
        className="menu-button"
        onClick={() => setOpen(!open)}
        aria-label={open ? 'Close menu' : 'Open menu'}
        aria-expanded={open}
        aria-controls="site-nav"
      >
        <SafeIcon icon={open ? FiIcons.FiX : FiIcons.FiMenu} />
      </button>

      <nav
        id="site-nav"
        className={`nav ${open ? 'nav--open' : ''}`}
        aria-label="Main"
      >
        <a
          href="#services"
          onClick={(event) => scrollToSection(event, 'services')}
        >
          Services
        </a>
        <a
          href="#approach"
          onClick={(event) => scrollToSection(event, 'approach')}
        >
          Approach
        </a>
        <a
          href="#results"
          onClick={(event) => scrollToSection(event, 'results')}
        >
          Our Mission
        </a>
        <Link to="/privacy" onClick={closeMenu}>
          Privacy Policy
        </Link>
        <a
          className="nav-cta"
          href="#contact"
          onClick={(event) => scrollToSection(event, 'contact')}
        >
          Start a project
          <SafeIcon icon={FiIcons.FiArrowUpRight} aria-hidden="true" />
        </a>
      </nav>
    </header>
  );
}

export default Header;